import { createSectionTitle, createSummaryTitle, createTable, parseHtmlContent } from '../utils';

export const renderFamilyHistory = (data, title) => {
  const content = [];

  content.push(createSectionTitle(title));

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if row data is meaningful
  const hasValidRows = (rows) => {
    if (!rows || !Array.isArray(rows) || rows.length === 0) return false;
    return rows.some((item) => {
      return (
        item.medicalCondition?.label ||
        item.medicalCondition?.value ||
        item.motherSide ||
        item.fatherSide ||
        item.sibling ||
        (item.notes && item.notes.trim() !== '') ||
        (item.note && item.note.trim() !== '')
      );
    });
  };

  // Check if there's any meaningful data to display
  const hasRows = hasValidRows(data.row);
  const hasNarrative = data && data.narrative && data.narrative.trim() !== '';

  // If no meaningful data and no narrative, show "No data"
  if (!hasRows && !hasNarrative) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  if (hasRows) {
    const headers = ['Medical condition', 'Inheritance', 'Note'];
    const rows = data.row
      .filter((item) => {
        // Filter out empty rows
        const hasCondition = item.medicalCondition?.label || item.medicalCondition?.value;
        const hasInheritance = item.motherSide || item.fatherSide || item.sibling;
        const hasNotes =
          (item.notes && item.notes.trim() !== '') || (item.note && item.note.trim() !== '');
        return hasCondition || hasInheritance || hasNotes;
      })
      .map((item) => {
        const sides = [];
        if (item.motherSide) sides.push('Mother side');
        if (item.fatherSide) sides.push('Father side');
        if (item.sibling) sides.push('Sibling');
        const inheritanceText = sides.length > 0 ? sides.join(', ') : '';

        return [
          {
            text: item.medicalCondition?.label || item.medicalCondition?.value || '-',
            style: 'tableCell'
          },
          { text: inheritanceText || '-', style: 'tableCell' },
          { text: item.notes || item.note || '-', style: 'tableCell' }
        ];
      });

    if (rows.length > 0) {
      content.push(createTable(headers, rows, ['33%', '33%', '34%']));
    }
  }

  // Show narrative if it exists
  if (hasNarrative) {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
